import React, { useState, useRef, useContext, createContext } from 'react';
const AdornmentContext = createContext({});
const AdornmentProvider = ({ children }) => {
    const [position, setPosition] = useState('right');
    const [isMasked, setMasked] = useState(true);
    const [inputValue, setInputValue] = useState('');
    const [isBlurred, setIsBlurred] = useState(false);
    const [inputRef, setInputRef] = useState({
        current: undefined,
    });
    const [maskRef, setMaskRef] = useState({
        current: undefined,
    });
    const [onBlurRelatedTarget, setOnBlurRelatedTarget] = React.useState(null);
    const staticCallback = useRef();
    const clickCallback = staticCallback.current;
    return (React.createElement(AdornmentContext.Provider, { value: {
            position,
            setPosition,
            inputValue,
            setInputValue,
            isMasked,
            setMasked,
            maskRef,
            setMaskRef,
            isBlurred,
            setIsBlurred,
            inputRef,
            setInputRef,
            clickCallback,
            setClickCallback: (value) => {
                staticCallback.current = value;
            },
            onBlurRelatedTarget,
            setOnBlurRelatedTarget,
        } }, children));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const containsDefinedValue = (values) => values.some(value => value !== undefined);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkContextValues = (values, hookName) => {
    if (!containsDefinedValue(values)) {
        throw new Error(`${hookName} must be called within a child of the AdornmentProvider`);
    }
};
const useAdornmentState = () => {
    const { position, setPosition, inputValue, setInputValue, isBlurred, setIsBlurred, inputRef, setInputRef, onBlurRelatedTarget, setOnBlurRelatedTarget, } = useContext(AdornmentContext);
    checkContextValues([position, setPosition, inputValue, setInputValue], 'useAdornmentState');
    return {
        position,
        setPosition,
        inputValue,
        setInputValue,
        isBlurred,
        setIsBlurred,
        inputRef,
        setInputRef,
        onBlurRelatedTarget,
        setOnBlurRelatedTarget,
    };
};
const usePasswordMaskAdornment = () => {
    const { isMasked, setMasked, inputValue, maskRef, setMaskRef } = useContext(AdornmentContext);
    checkContextValues([isMasked, setMasked, inputValue], 'usePasswordMaskAdornment');
    return { isMasked, setMasked, inputValue, maskRef, setMaskRef };
};
const useSearchAdornment = () => {
    const { clickCallback, setClickCallback } = useContext(AdornmentContext);
    checkContextValues([clickCallback, setClickCallback], 'useSearchAdornment');
    return { clickCallback, setClickCallback };
};
export { AdornmentProvider, AdornmentContext, useAdornmentState, usePasswordMaskAdornment, useSearchAdornment, };
//# sourceMappingURL=AdornmentProvider.js.map